import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { Input } from "@repo/ui/components/ui/input";
import { useQuery } from "@tanstack/react-query";
import { Loader2, MapPin, X } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PlacePicker(t0) {
  const $ = _c(40);
  const {
    value,
    onChange
  } = t0;
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);
  let t1;
  if ($[0] !== search) {
    t1 = trpc.places.search.queryOptions({
      query: search,
      limit: 10
    });
    $[0] = search;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = search.length >= 2;
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      ...t1,
      enabled: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: t4,
    isLoading
  } = useQuery(t3);
  let t5;
  if ($[5] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const results = t5;
  let t6;
  if ($[7] !== value) {
    t6 = trpc.places.byId.queryOptions({
      id: value
    });
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const t7 = !!value;
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = {
      ...t6,
      enabled: t7
    };
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const {
    data: selected
  } = useQuery(t8);
  let t10;
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      const handleClick = function handleClick(e) {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClick);
      return () => document.removeEventListener("mousedown", handleClick);
    };
    t10 = [];
    $[12] = t10;
    $[13] = t9;
  } else {
    t10 = $[12];
    t9 = $[13];
  }
  useEffect(t9, t10);
  if (value && selected) {
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = /*#__PURE__*/_jsx("div", {
        className: "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand/10",
        children: /*#__PURE__*/_jsx(MapPin, {
          className: "h-4 w-4 text-brand"
        })
      });
      $[14] = t11;
    } else {
      t11 = $[14];
    }
    let t12;
    if ($[15] !== selected.name) {
      t12 = /*#__PURE__*/_jsx("div", {
        className: "min-w-0 flex-1",
        children: /*#__PURE__*/_jsx("p", {
          className: "truncate text-sm font-medium text-gray-900",
          children: selected.name
        })
      });
      $[15] = selected.name;
      $[16] = t12;
    } else {
      t12 = $[16];
    }
    let t13;
    if ($[17] !== onChange) {
      t13 = () => onChange(null);
      $[17] = onChange;
      $[18] = t13;
    } else {
      t13 = $[18];
    }
    let t14;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = /*#__PURE__*/_jsx(X, {
        className: "h-4 w-4"
      });
      $[19] = t14;
    } else {
      t14 = $[19];
    }
    let t15;
    if ($[20] !== t13) {
      t15 = /*#__PURE__*/_jsx(Button, {
        variant: "ghost",
        size: "sm",
        onClick: t13,
        className: "h-7 w-7 p-0 text-gray-400 hover:text-gray-600",
        children: t14
      });
      $[20] = t13;
      $[21] = t15;
    } else {
      t15 = $[21];
    }
    let t16;
    if ($[22] !== t12 || $[23] !== t15) {
      t16 = /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-3 rounded-lg border bg-gray-50 p-3",
        children: [t11, t12, t15]
      });
      $[22] = t12;
      $[23] = t15;
      $[24] = t16;
    } else {
      t16 = $[24];
    }
    return t16;
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e_0 => {
      setSearch(e_0.target.value);
      setIsOpen(true);
    };
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== search.length) {
    t12 = () => search.length >= 2 && setIsOpen(true);
    $[26] = search.length;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== search || $[29] !== t12) {
    t13 = /*#__PURE__*/_jsx(Input, {
      placeholder: "S\xF6k plats att koppla...",
      value: search,
      onChange: t11,
      onFocus: t12
    });
    $[28] = search;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== isLoading || $[32] !== isOpen || $[33] !== onChange || $[34] !== results || $[35] !== search.length) {
    t14 = isOpen && search.length >= 2 && /*#__PURE__*/_jsx("div", {
      className: "absolute top-full z-50 mt-1 max-h-60 w-full overflow-y-auto rounded-lg border bg-white shadow-lg",
      children: isLoading ? /*#__PURE__*/_jsx("div", {
        className: "flex items-center justify-center py-4",
        children: /*#__PURE__*/_jsx(Loader2, {
          className: "h-4 w-4 animate-spin text-gray-400"
        })
      }) : results.length === 0 ? /*#__PURE__*/_jsx("div", {
        className: "px-3 py-4 text-center text-sm text-gray-500",
        children: "Inga platser hittades"
      }) : results.map(place => /*#__PURE__*/_jsxs("button", {
        onClick: () => {
          onChange(place.id);
          setSearch("");
          setIsOpen(false);
        },
        className: "flex w-full items-center gap-3 px-3 py-2.5 text-left transition-colors hover:bg-gray-50",
        children: [/*#__PURE__*/_jsx(MapPin, {
          className: "h-4 w-4 shrink-0 text-gray-400"
        }), /*#__PURE__*/_jsxs("div", {
          className: "min-w-0",
          children: [/*#__PURE__*/_jsx("p", {
            className: "truncate text-sm font-medium text-gray-900",
            children: place.name
          }), place.categoryName && /*#__PURE__*/_jsx("p", {
            className: "truncate text-xs text-gray-500",
            children: place.categoryName
          })]
        })]
      }, place.id))
    });
    $[31] = isLoading;
    $[32] = isOpen;
    $[33] = onChange;
    $[34] = results;
    $[35] = search.length;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t13 || $[38] !== t14) {
    t15 = /*#__PURE__*/_jsxs("div", {
      ref: containerRef,
      className: "relative",
      children: [t13, t14]
    });
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  return t15;
}